'use strict';
import React from 'react';
import { createRoot } from 'react-dom/client';
import { Provider } from 'react-redux';
import './theme/css/bootstrap.css';
import './index.scss';
import './theme/theme.css';
import 'react-toastify/dist/ReactToastify.css';
import App from './App.jsx';
import { unregister } from './registerServiceWorker.js';
import WebFont from 'webfontloader';
import store from './store/store.js';
import { createBrowserHistory } from 'history';
import { ThemeContextProvider } from './theme/index.jsx';
const history = createBrowserHistory();
self.$RefreshReg$ = () => {};
self.$RefreshSig$ = () => () => {};

WebFont.load({
	google: {
		families: [
			'Inter:300,400,500,600,700,800',
			'Lato',
			'Space Mono',
			'Inconsolata',
			'Source Sans Pro',
			'Source Serif Pro',
			'EB Garamond',
			'sans-serif'
		]
	}
});

import { Auth0Provider } from '@auth0/auth0-react';
import { Auth0TokenProvider } from './contexts/Auth0TokenContext';
import * as config from './config/env.config';

const root = createRoot(document.getElementById('root'));
root.render(
	(<Provider store={store}>
		<Auth0Provider
			domain={config.AUTH_DOMAIN}
			clientId={config.AUTH_CLIENTID}
			authorizationParams={{
				redirect_uri: config.AUTH_CALLBACKURL,
				audience: 'https://portal-api',
				scope: 'openid email profile offline_access write:user write:user/action write:user/permission write:user/permission/project write:project/view write:project/download write:chemical/view write:chemical/download write:compound/view write:compound/download'
			}}
			useRefreshTokens={true}
			cacheLocation="localstorage"
		>
			<Auth0TokenProvider>
				<ThemeContextProvider><App history={history} /></ThemeContextProvider>
			</Auth0TokenProvider>
		</Auth0Provider>
	</Provider>),
);
//registerServiceWorker();
//Unregistering service worker in order to bust caching
unregister();